import { Text } from '@lmc/ui-kit/src/general'
import { Popover } from 'antd'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import type { ChargeReconciliationRow } from '../../../../Reports/types/chargeReconciliation'

type CancelledEventPopoverProps = {
  children: ReactNode
  row: ChargeReconciliationRow
}

const CancelledEventPopover = ({
  children,
  row
}: CancelledEventPopoverProps) => {
  const { t } = useTranslation()

  const hasCancellationDetails =
    row.cancelledBy ||
    row.cancelledReason ||
    row.cancelledFinancialImpact ||
    row.cancelledPreventable ||
    row.cancelledNotes

  if (!hasCancellationDetails) {
    return <>{children}</>
  }

  return (
    <Popover
      placement="top"
      showArrow
      trigger="hover"
      arrow={{ pointAtCenter: true }}
      content={
        <ContentContainer>
          {row.cancelledBy && (
            <Row>
              <RowLabel level={2}>{t('WHO_CAUSED_CANCELLATION')}</RowLabel>
              <RowValue>{row.cancelledBy}</RowValue>
            </Row>
          )}
          {row.cancelledReason && (
            <Row>
              <RowLabel level={2}>{t('CANCEL_REASON')}</RowLabel>
              <RowValue>{row.cancelledReason}</RowValue>
            </Row>
          )}
          {row.cancelledFinancialImpact && (
            <Row>
              <RowLabel level={2}>{t('FINANCIAL_IMPACT')}</RowLabel>
              <RowValue>{row.cancelledFinancialImpact}</RowValue>
            </Row>
          )}
          {row.cancelledPreventable && (
            <Row>
              <RowLabel level={2}>{t('PREVENTION')}</RowLabel>
              <RowValue>{t('CANCELLATION_PREVENTED')}</RowValue>
            </Row>
          )}
          {row.cancelledNotes && (
            <Row>
              <RowLabel level={2}>{t('CANCEL_NOTES')}</RowLabel>
              <RowValue>{row.cancelledNotes}</RowValue>
            </Row>
          )}
        </ContentContainer>
      }
    >
      {children}
    </Popover>
  )
}

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 260px;
`

const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const RowLabel = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
`

const RowValue = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
`

export default CancelledEventPopover
